import React from 'react'
import { Alert, Button, Card, CardBody } from 'reactstrap'
import { NoResult } from './../../components'

export function CashMahanError(props) {
  return (
    <Card>
      <CardBody className='shadow' style={{ textAlign: 'center', padding: '6%' }}>
        <Alert color='danger' style={{ whiteSpace: 'pre-wrap' }}>{props.message || 'Unable to load Cash Mahan data'}</Alert>
        {props.onRetry ? (
          <Button className='actionsBtn' onClick={props.onRetry}>Retry</Button>
        ) : null}
      </CardBody>
    </Card>
  )
}

export function CashMahanEmpty(props) {
  if (props.message) {
    return (
      <CardBody className='shadow' style={{ textAlign: 'center', color: '#777', padding: '10%' }}>
        <i className="fas fa-heart-broken" style={{ fontSize: 50, marginBottom: '2%' }}></i>
        <h2>{props.message}</h2>
        {props.onRetry ? (
          <Button className='actionsBtn' onClick={props.onRetry}>Refresh</Button>
        ) : null}
      </CardBody>
    )
  }
  return <NoResult />
}
